var EmAlta;

if( !String.linkify ){

    String.prototype.linkify = function() {

        // http://, https://, ftp://
        var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

        // www. sans http:// or https://
        var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

        // Email addresses
        var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

        // Force all HTTPS


        return this
            .toLowerCase()
            .replace( 'http://', 'https://' )
            .replace(urlPattern, '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>')
            .replace(pseudoUrlPattern, '$1<a href="https://$2" target="_blank" rel="noopener noreferrer">$2</a>')
            .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>')
        ;

    };
    
}

(function($){

    EmAlta = {

        $ : null,
        blogID : null,

        init : function(){

            this.$ = $( '#em-alta' );
            if( !this.$.length ) return true;

            // Blog ID
            this.blogID = this.$.data( 'blog-id' );
            // Items list
            this.$list = $( 'ul', this.$ );
            // Model
            this.$model = this.$list.children( 'li' ).clone();
            // Remove model
            this.$list.children( 'li' ).remove();

            var URL = Piki.blogurl + '/wp-content/vtracker/blog-' + this.blogID + '-twitter.json';
            Filters.request = $.ajax({
                method: 'GET',
                dataType : 'JSON',
                url: URL
            });
            Filters.request.done(function( response ){
                if( response.length ){
                    EmAlta.receiveItems( response );
                }
                else {
                    EmAlta.$.remove();
                }
            });
            Filters.request.fail(function( jqXHR, textStatus ) {
                EmAlta.$.remove();
                Loader( 'close' );
                console.info( 'Request failed: ' + textStatus );
            });

        },

        receiveItems : function( items ){

            $.each( items, function(){

                // Start Link
                var startLink = this.conteudo.lastIndexOf( this.link );
                if( startLink < 0 ){
                    this.link = this.link.replace( 'http://', 'https://' );
                    startLink = this.conteudo.lastIndexOf( this.link );
                }
                if( startLink >= 0 ){
                    this.conteudo = this.conteudo.substr( 0, ( startLink - 1 ) );
                }

                // Limit words
                var contentSplited = this.conteudo.split( ' ' );
                if( contentSplited.length > 20 ){
                    this.conteudo = contentSplited.slice( 0, 20 ).join( ' ' ) + '...';
                }

                // Add Link
                this.conteudo = this.conteudo.linkify() + '<br><a href="' + this.link + '" title="Ver publicação" target="_blank">Ver publicação</a>'

                // Create html element
                var $new = EmAlta.$model.clone().appendTo( EmAlta.$list );
                $new.find( 'h4 strong' ).text( '@' + this.publicador_nome );
                $new.find( 'em' ).html( this.conteudo );
                $new.find( 'picture' ).html( '<img src="' + this.publicador_foto.replace( 'http://', 'https://' ) + '" alt="' + this.publicador_nomecompleto + '">' );                
            
            });

        }

    };

    $(function(){ 
        EmAlta.init();  
    });

})(jQuery);
